/*
 * Copyright (c) 2020. American Express Company
 */

import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import CardService from '../../services/card.service';
import FinanceService, { CanAffordPurchase } from '../../services/finance.service';
import FormatService from '../../services/format.service';
import LiteralsService from '../../services/literals/LiteralsService';

// components
import BwSlider from '../bw-slider/BwSlider';
import GoalDrawer from './GoalDrawer';
import Output from '../atomic/molecules/output/Output';
import SavingsGoal from 'src/bw/bw-drawer/common/SavingsGoal';

// icons and style
import { ReactComponent as EiffelTower } from 'src/bw/goal/eiffel-tower.svg';
import { CardModel } from 'src/types/card.model';

export default class TakeVacationDrawer extends Component<any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;
        const card = drawerProps.card;

        const demoMode: boolean =
            _.get(this.props, 'mentor.state') === 'updateGoal' &&
            _.get(this.props, 'mentor.goal') === 'take a vacation';

        const vacationCost = Math.abs(_.get(card, 'attributes.totalAmount', 0));

        const canAfford: CanAffordPurchase = FinanceService.canAffordPurchase(
            card.startDate,
            vacationCost,
            card.monthlySavings,
            card.monthlyFreeCash
        );

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={<EiffelTower />}
                introContent={LiteralsService.getLiteral('TakeVacationDrawer.body')}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                startDateLabel={LiteralsService.getLiteral('TakeVacationDrawer.startDate')}
            >
                <Output
                    title="Planning for vacation cost of:"
                    main={FormatService.format(vacationCost)}
                    canAfford={canAfford}
                />

                <BwSlider
                    id="vacation-cost-slider"
                    label="Total vacation costs"
                    value={vacationCost}
                    formattedValue={FormatService.formatCompactMoney(vacationCost)}
                    step={100}
                    min={500}
                    max={50000}
                    onChange={(value: any) => this.handleSaveCost(value)}
                    onDone={(value: any) => this.handleUpdateSavingsGoal(value)}
                    key="vacation-cost-slider"
                    inputToggleText="Add a precise cost"
                />

                <SavingsGoal
                    drawerProps={drawerProps}
                    demoMode={demoMode}
                    user={this.props.user}
                    setDrawer={this.props.setDrawer}
                    handleOpenSignup={() => {
                        console.warn('Deprecated: handleOpenSignup (Take Vacation)');
                        this.props.handleOpenSignup();
                    }}
                    handleCreateLinkedSavingsCard={this.props.handleCreateLinkedSavingsCard}
                    handleChangeCardAttribute={this.props.handleChangeCardAttribute}
                    handleUpdateCard={this.props.handleUpdateCard}
                    handleDeleteCard={this.props.handleDeleteCard}
                />
            </GoalDrawer>
        );
    }

    private handleSaveCost(value: number): void {
        this.props.handleChangeCardAttribute(this.props.drawerProps.card, -Number(value || 0), 'totalAmount');
    }

    private handleUpdateSavingsGoal(value: number): void {
        if (CardService.hasSavingsGoal(this.props)) {
            const updatedCard: CardModel = CardService.getSavingsGoal(this.props);
            _.set(updatedCard, 'attributes.targetBalance', Number(value || 0));
            this.props.handleUpdateCard(updatedCard);
        }
    }
}
